function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
var _excluded = ["analyticsName", "phone", "email", "name", "loginHeaderText", "registrationHeaderText", "loginSubHeaderText", "registrationSubHeaderText", "emailLoading", "passwordLoading", "error", "phoneNumberInputOptional", "phoneNumberInputHidden", "openForgotPasswordInNewTab", "showGoogleAuth", "overrideHasSubmittedEmailCheckForLogin", "emailMismatch", "customEmailValidityCheck", "customEmailValidityCheckDelay", "requestResetPassword", "hidePasswordField", "onPasswordlessLoginRequest", "onboardingAccountPageCTA", "fullNamePlaceholder", "fullNameLabel", "disclaimerProps", "passwordFormActionText", "EmailInput", "NameInput", "PhoneInput", "PasswordInput", "onHumanStatusRequest", "onLogin", "onRegister", "postEmailCtaSection", "unsetContainer", "fullNameOptional", "fullNameHidden"];
function cov_173s6xv8tv() {
  var path = "/__w/code/code/js/packages/cinderblocks/src/platform/auth/AccountForm.tsx";
  var hash = "482117482636475e89d933b83b0bb6fb3c071f42";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/cinderblocks/src/platform/auth/AccountForm.tsx",
    statementMap: {
      "0": {
        start: {
          line: 25,
          column: 25
        },
        end: {
          line: 25,
          column: 99
        }
      },
      "1": {
        start: {
          line: 28,
          column: 26
        },
        end: {
          line: 30,
          column: 1
        }
      },
      "2": {
        start: {
          line: 29,
          column: 2
        },
        end: {
          line: 29,
          column: 77
        }
      },
      "3": {
        start: {
          line: 162,
          column: 49
        },
        end: {
          line: 493,
          column: 1
        }
      },
      "4": {
        start: {
          line: 203,
          column: 28
        },
        end: {
          line: 203,
          column: 58
        }
      },
      "5": {
        start: {
          line: 205,
          column: 24
        },
        end: {
          line: 205,
          column: 36
        }
      },
      "6": {
        start: {
          line: 206,
          column: 27
        },
        end: {
          line: 206,
          column: 39
        }
      },
      "7": {
        start: {
          line: 208,
          column: 2
        },
        end: {
          line: 213,
          column: 9
        }
      },
      "8": {
        start: {
          line: 209,
          column: 4
        },
        end: {
          line: 212,
          column: 5
        }
      },
      "9": {
        start: {
          line: 210,
          column: 25
        },
        end: {
          line: 210,
          column: 66
        }
      },
      "10": {
        start: {
          line: 211,
          column: 6
        },
        end: {
          line: 211,
          column: 25
        }
      },
      "11": {
        start: {
          line: 215,
          column: 26
        },
        end: {
          line: 215,
          column: 55
        }
      },
      "12": {
        start: {
          line: 219,
          column: 38
        },
        end: {
          line: 219,
          column: 73
        }
      },
      "13": {
        start: {
          line: 221,
          column: 58
        },
        end: {
          line: 223,
          column: 3
        }
      },
      "14": {
        start: {
          line: 225,
          column: 54
        },
        end: {
          line: 225,
          column: 78
        }
      },
      "15": {
        start: {
          line: 228,
          column: 4
        },
        end: {
          line: 228,
          column: 28
        }
      },
      "16": {
        start: {
          line: 231,
          column: 4
        },
        end: {
          line: 231,
          column: 23
        }
      },
      "17": {
        start: {
          line: 234,
          column: 4
        },
        end: {
          line: 234,
          column: 38
        }
      },
      "18": {
        start: {
          line: 236,
          column: 22
        },
        end: {
          line: 239,
          column: 3
        }
      },
      "19": {
        start: {
          line: 237,
          column: 4
        },
        end: {
          line: 237,
          column: 33
        }
      },
      "20": {
        start: {
          line: 238,
          column: 4
        },
        end: {
          line: 238,
          column: 29
        }
      },
      "21": {
        start: {
          line: 241,
          column: 28
        },
        end: {
          line: 244,
          column: 3
        }
      },
      "22": {
        start: {
          line: 242,
          column: 4
        },
        end: {
          line: 242,
          column: 32
        }
      },
      "23": {
        start: {
          line: 243,
          column: 4
        },
        end: {
          line: 243,
          column: 68
        }
      },
      "24": {
        start: {
          line: 246,
          column: 25
        },
        end: {
          line: 249,
          column: 3
        }
      },
      "25": {
        start: {
          line: 247,
          column: 4
        },
        end: {
          line: 247,
          column: 33
        }
      },
      "26": {
        start: {
          line: 248,
          column: 4
        },
        end: {
          line: 248,
          column: 45
        }
      },
      "27": {
        start: {
          line: 251,
          column: 28
        },
        end: {
          line: 260,
          column: 3
        }
      },
      "28": {
        start: {
          line: 253,
          column: 6
        },
        end: {
          line: 255,
          column: 7
        }
      },
      "29": {
        start: {
          line: 254,
          column: 8
        },
        end: {
          line: 254,
          column: 48
        }
      },
      "30": {
        start: {
          line: 256,
          column: 6
        },
        end: {
          line: 256,
          column: 22
        }
      },
      "31": {
        start: {
          line: 257,
          column: 6
        },
        end: {
          line: 257,
          column: 20
        }
      },
      "32": {
        start: {
          line: 262,
          column: 41
        },
        end: {
          line: 270,
          column: 3
        }
      },
      "33": {
        start: {
          line: 263,
          column: 4
        },
        end: {
          line: 269,
          column: 5
        }
      },
      "34": {
        start: {
          line: 264,
          column: 6
        },
        end: {
          line: 264,
          column: 45
        }
      },
      "35": {
        start: {
          line: 266,
          column: 26
        },
        end: {
          line: 266,
          column: 65
        }
      },
      "36": {
        start: {
          line: 267,
          column: 6
        },
        end: {
          line: 267,
          column: 46
        }
      },
      "37": {
        start: {
          line: 268,
          column: 6
        },
        end: {
          line: 268,
          column: 58
        }
      },
      "38": {
        start: {
          line: 273,
          column: 26
        },
        end: {
          line: 278,
          column: 3
        }
      },
      "39": {
        start: {
          line: 274,
          column: 4
        },
        end: {
          line: 274,
          column: 24
        }
      },
      "40": {
        start: {
          line: 275,
          column: 4
        },
        end: {
          line: 275,
          column: 17
        }
      },
      "41": {
        start: {
          line: 276,
          column: 4
        },
        end: {
          line: 276,
          column: 35
        }
      },
      "42": {
        start: {
          line: 277,
          column: 4
        },
        end: {
          line: 277,
          column: 25
        }
      },
      "43": {
        start: {
          line: 280,
          column: 34
        },
        end: {
          line: 286,
          column: 3
        }
      },
      "44": {
        start: {
          line: 281,
          column: 4
        },
        end: {
          line: 283,
          column: 5
        }
      },
      "45": {
        start: {
          line: 282,
          column: 6
        },
        end: {
          line: 282,
          column: 54
        }
      },
      "46": {
        start: {
          line: 285,
          column: 4
        },
        end: {
          line: 285,
          column: 47
        }
      },
      "47": {
        start: {
          line: 288,
          column: 2
        },
        end: {
          line: 298,
          column: 9
        }
      },
      "48": {
        start: {
          line: 289,
          column: 4
        },
        end: {
          line: 289,
          column: 27
        }
      },
      "49": {
        start: {
          line: 294,
          column: 4
        },
        end: {
          line: 296,
          column: 5
        }
      },
      "50": {
        start: {
          line: 295,
          column: 6
        },
        end: {
          line: 295,
          column: 38
        }
      },
      "51": {
        start: {
          line: 300,
          column: 2
        },
        end: {
          line: 303,
          column: 53
        }
      },
      "52": {
        start: {
          line: 301,
          column: 4
        },
        end: {
          line: 301,
          column: 38
        }
      },
      "53": {
        start: {
          line: 302,
          column: 4
        },
        end: {
          line: 302,
          column: 56
        }
      },
      "54": {
        start: {
          line: 305,
          column: 29
        },
        end: {
          line: 305,
          column: 42
        }
      },
      "55": {
        start: {
          line: 306,
          column: 2
        },
        end: {
          line: 318,
          column: 4
        }
      },
      "56": {
        start: {
          line: 308,
          column: 6
        },
        end: {
          line: 310,
          column: 7
        }
      },
      "57": {
        start: {
          line: 309,
          column: 8
        },
        end: {
          line: 309,
          column: 62
        }
      },
      "58": {
        start: {
          line: 311,
          column: 6
        },
        end: {
          line: 314,
          column: 7
        }
      },
      "59": {
        start: {
          line: 312,
          column: 8
        },
        end: {
          line: 312,
          column: 42
        }
      },
      "60": {
        start: {
          line: 313,
          column: 8
        },
        end: {
          line: 313,
          column: 42
        }
      },
      "61": {
        start: {
          line: 320,
          column: 32
        },
        end: {
          line: 320,
          column: 87
        }
      },
      "62": {
        start: {
          line: 322,
          column: 28
        },
        end: {
          line: 322,
          column: 96
        }
      },
      "63": {
        start: {
          line: 332,
          column: 4
        },
        end: {
          line: 337,
          column: 21
        }
      },
      "64": {
        start: {
          line: 339,
          column: 2
        },
        end: {
          line: 348,
          column: 74
        }
      },
      "65": {
        start: {
          line: 340,
          column: 4
        },
        end: {
          line: 343,
          column: 5
        }
      },
      "66": {
        start: {
          line: 341,
          column: 6
        },
        end: {
          line: 341,
          column: 41
        }
      },
      "67": {
        start: {
          line: 342,
          column: 6
        },
        end: {
          line: 342,
          column: 13
        }
      },
      "68": {
        start: {
          line: 345,
          column: 4
        },
        end: {
          line: 347,
          column: 5
        }
      },
      "69": {
        start: {
          line: 346,
          column: 6
        },
        end: {
          line: 346,
          column: 42
        }
      },
      "70": {
        start: {
          line: 350,
          column: 2
        },
        end: {
          line: 362,
          column: 3
        }
      },
      "71": {
        start: {
          line: 351,
          column: 4
        },
        end: {
          line: 361,
          column: 6
        }
      },
      "72": {
        start: {
          line: 364,
          column: 2
        },
        end: {
          line: 372,
          column: 3
        }
      },
      "73": {
        start: {
          line: 365,
          column: 4
        },
        end: {
          line: 371,
          column: 6
        }
      },
      "74": {
        start: {
          line: 375,
          column: 25
        },
        end: {
          line: 375,
          column: 71
        }
      },
      "75": {
        start: {
          line: 376,
          column: 26
        },
        end: {
          line: 376,
          column: 28
        }
      },
      "76": {
        start: {
          line: 377,
          column: 2
        },
        end: {
          line: 387,
          column: 3
        }
      },
      "77": {
        start: {
          line: 378,
          column: 4
        },
        end: {
          line: 378,
          column: 59
        }
      },
      "78": {
        start: {
          line: 379,
          column: 9
        },
        end: {
          line: 387,
          column: 3
        }
      },
      "79": {
        start: {
          line: 380,
          column: 4
        },
        end: {
          line: 386,
          column: 5
        }
      },
      "80": {
        start: {
          line: 381,
          column: 6
        },
        end: {
          line: 381,
          column: 51
        }
      },
      "81": {
        start: {
          line: 382,
          column: 11
        },
        end: {
          line: 386,
          column: 5
        }
      },
      "82": {
        start: {
          line: 383,
          column: 6
        },
        end: {
          line: 383,
          column: 50
        }
      },
      "83": {
        start: {
          line: 385,
          column: 6
        },
        end: {
          line: 385,
          column: 55
        }
      },
      "84": {
        start: {
          line: 388,
          column: 19
        },
        end: {
          line: 388,
          column: 79
        }
      },
      "85": {
        start: {
          line: 390,
          column: 2
        },
        end: {
          line: 394,
          column: 3
        }
      },
      "86": {
        start: {
          line: 391,
          column: 4
        },
        end: {
          line: 391,
          column: 99
        }
      },
      "87": {
        start: {
          line: 392,
          column: 9
        },
        end: {
          line: 394,
          column: 3
        }
      },
      "88": {
        start: {
          line: 393,
          column: 4
        },
        end: {
          line: 393,
          column: 34
        }
      },
      "89": {
        start: {
          line: 396,
          column: 2
        },
        end: {
          line: 492,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 28,
            column: 26
          },
          end: {
            line: 28,
            column: 27
          }
        },
        loc: {
          start: {
            line: 29,
            column: 2
          },
          end: {
            line: 29,
            column: 77
          }
        },
        line: 29
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 162,
            column: 49
          },
          end: {
            line: 162,
            column: 50
          }
        },
        loc: {
          start: {
            line: 202,
            column: 6
          },
          end: {
            line: 493,
            column: 1
          }
        },
        line: 202
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 208,
            column: 12
          },
          end: {
            line: 208,
            column: 13
          }
        },
        loc: {
          start: {
            line: 208,
            column: 18
          },
          end: {
            line: 213,
            column: 3
          }
        },
        line: 208
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 236,
            column: 22
          },
          end: {
            line: 236,
            column: 23
          }
        },
        loc: {
          start: {
            line: 236,
            column: 44
          },
          end: {
            line: 239,
            column: 3
          }
        },
        line: 236
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 241,
            column: 28
          },
          end: {
            line: 241,
            column: 29
          }
        },
        loc: {
          start: {
            line: 241,
            column: 80
          },
          end: {
            line: 244,
            column: 3
          }
        },
        line: 241
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 246,
            column: 25
          },
          end: {
            line: 246,
            column: 26
          }
        },
        loc: {
          start: {
            line: 246,
            column: 76
          },
          end: {
            line: 249,
            column: 3
          }
        },
        line: 246
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 252,
            column: 4
          },
          end: {
            line: 252,
            column: 5
          }
        },
        loc: {
          start: {
            line: 252,
            column: 44
          },
          end: {
            line: 258,
            column: 5
          }
        },
        line: 252
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 262,
            column: 41
          },
          end: {
            line: 262,
            column: 42
          }
        },
        loc: {
          start: {
            line: 262,
            column: 53
          },
          end: {
            line: 270,
            column: 3
          }
        },
        line: 262
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 273,
            column: 26
          },
          end: {
            line: 273,
            column: 27
          }
        },
        loc: {
          start: {
            line: 273,
            column: 33
          },
          end: {
            line: 278,
            column: 3
          }
        },
        line: 273
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 280,
            column: 34
          },
          end: {
            line: 280,
            column: 35
          }
        },
        loc: {
          start: {
            line: 280,
            column: 95
          },
          end: {
            line: 286,
            column: 3
          }
        },
        line: 280
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 288,
            column: 12
          },
          end: {
            line: 288,
            column: 13
          }
        },
        loc: {
          start: {
            line: 288,
            column: 18
          },
          end: {
            line: 298,
            column: 3
          }
        },
        line: 288
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 300,
            column: 12
          },
          end: {
            line: 300,
            column: 13
          }
        },
        loc: {
          start: {
            line: 300,
            column: 18
          },
          end: {
            line: 303,
            column: 3
          }
        },
        line: 300
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 307,
            column: 4
          },
          end: {
            line: 307,
            column: 5
          }
        },
        loc: {
          start: {
            line: 307,
            column: 10
          },
          end: {
            line: 315,
            column: 5
          }
        },
        line: 307
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 339,
            column: 12
          },
          end: {
            line: 339,
            column: 13
          }
        },
        loc: {
          start: {
            line: 339,
            column: 18
          },
          end: {
            line: 348,
            column: 3
          }
        },
        line: 339
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 164,
            column: 2
          },
          end: {
            line: 164,
            column: 12
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 164,
            column: 10
          },
          end: {
            line: 164,
            column: 12
          }
        }],
        line: 164
      },
      "1": {
        loc: {
          start: {
            line: 165,
            column: 9
          },
          end: {
            line: 165,
            column: 26
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 165,
            column: 24
          },
          end: {
            line: 165,
            column: 26
          }
        }],
        line: 165
      },
      "2": {
        loc: {
          start: {
            line: 166,
            column: 8
          },
          end: {
            line: 166,
            column: 24
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 166,
            column: 22
          },
          end: {
            line: 166,
            column: 24
          }
        }],
        line: 166
      },
      "3": {
        loc: {
          start: {
            line: 177,
            column: 2
          },
          end: {
            line: 177,
            column: 24
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 177,
            column: 19
          },
          end: {
            line: 177,
            column: 24
          }
        }],
        line: 177
      },
      "4": {
        loc: {
          start: {
            line: 183,
            column: 2
          },
          end: {
            line: 183,
            column: 27
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 183,
            column: 22
          },
          end: {
            line: 183,
            column: 27
          }
        }],
        line: 183
      },
      "5": {
        loc: {
          start: {
            line: 209,
            column: 4
          },
          end: {
            line: 212,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 209,
            column: 4
          },
          end: {
            line: 212,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 209
      },
      "6": {
        loc: {
          start: {
            line: 253,
            column: 6
          },
          end: {
            line: 255,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 253,
            column: 6
          },
          end: {
            line: 255,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 253
      },
      "7": {
        loc: {
          start: {
            line: 263,
            column: 4
          },
          end: {
            line: 269,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 263,
            column: 4
          },
          end: {
            line: 269,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 263
      },
      "8": {
        loc: {
          start: {
            line: 281,
            column: 4
          },
          end: {
            line: 283,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 281,
            column: 4
          },
          end: {
            line: 283,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 281
      },
      "9": {
        loc: {
          start: {
            line: 281,
            column: 8
          },
          end: {
            line: 281,
            column: 46
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 281,
            column: 8
          },
          end: {
            line: 281,
            column: 21
          }
        }, {
          start: {
            line: 281,
            column: 25
          },
          end: {
            line: 281,
            column: 30
          }
        }, {
          start: {
            line: 281,
            column: 34
          },
          end: {
            line: 281,
            column: 46
          }
        }],
        line: 281
      },
      "10": {
        loc: {
          start: {
            line: 294,
            column: 4
          },
          end: {
            line: 296,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 294,
            column: 4
          },
          end: {
            line: 296,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 294
      },
      "11": {
        loc: {
          start: {
            line: 308,
            column: 6
          },
          end: {
            line: 310,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 308,
            column: 6
          },
          end: {
            line: 310,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 308
      },
      "12": {
        loc: {
          start: {
            line: 311,
            column: 6
          },
          end: {
            line: 314,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 311,
            column: 6
          },
          end: {
            line: 314,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 311
      },
      "13": {
        loc: {
          start: {
            line: 320,
            column: 32
          },
          end: {
            line: 320,
            column: 87
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 320,
            column: 32
          },
          end: {
            line: 320,
            column: 59
          }
        }, {
          start: {
            line: 320,
            column: 63
          },
          end: {
            line: 320,
            column: 87
          }
        }],
        line: 320
      },
      "14": {
        loc: {
          start: {
            line: 322,
            column: 28
          },
          end: {
            line: 322,
            column: 96
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 322,
            column: 28
          },
          end: {
            line: 322,
            column: 33
          }
        }, {
          start: {
            line: 322,
            column: 37
          },
          end: {
            line: 322,
            column: 53
          }
        }, {
          start: {
            line: 322,
            column: 57
          },
          end: {
            line: 322,
            column: 70
          }
        }, {
          start: {
            line: 322,
            column: 74
          },
          end: {
            line: 322,
            column: 96
          }
        }],
        line: 322
      },
      "15": {
        loc: {
          start: {
            line: 332,
            column: 4
          },
          end: {
            line: 337,
            column: 21
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 332,
            column: 4
          },
          end: {
            line: 332,
            column: 14
          }
        }, {
          start: {
            line: 333,
            column: 4
          },
          end: {
            line: 333,
            column: 21
          }
        }, {
          start: {
            line: 334,
            column: 4
          },
          end: {
            line: 334,
            column: 18
          }
        }, {
          start: {
            line: 335,
            column: 4
          },
          end: {
            line: 335,
            column: 26
          }
        }, {
          start: {
            line: 336,
            column: 4
          },
          end: {
            line: 336,
            column: 31
          }
        }, {
          start: {
            line: 337,
            column: 4
          },
          end: {
            line: 337,
            column: 21
          }
        }],
        line: 332
      },
      "16": {
        loc: {
          start: {
            line: 340,
            column: 4
          },
          end: {
            line: 343,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 340,
            column: 4
          },
          end: {
            line: 343,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 340
      },
      "17": {
        loc: {
          start: {
            line: 345,
            column: 4
          },
          end: {
            line: 347,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 345,
            column: 4
          },
          end: {
            line: 347,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 345
      },
      "18": {
        loc: {
          start: {
            line: 345,
            column: 8
          },
          end: {
            line: 345,
            column: 45
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 345,
            column: 8
          },
          end: {
            line: 345,
            column: 25
          }
        }, {
          start: {
            line: 345,
            column: 29
          },
          end: {
            line: 345,
            column: 45
          }
        }],
        line: 345
      },
      "19": {
        loc: {
          start: {
            line: 350,
            column: 2
          },
          end: {
            line: 362,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 350,
            column: 2
          },
          end: {
            line: 362,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 350
      },
      "20": {
        loc: {
          start: {
            line: 350,
            column: 6
          },
          end: {
            line: 350,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 350,
            column: 6
          },
          end: {
            line: 350,
            column: 23
          }
        }, {
          start: {
            line: 350,
            column: 27
          },
          end: {
            line: 350,
            column: 47
          }
        }],
        line: 350
      },
      "21": {
        loc: {
          start: {
            line: 352,
            column: 36
          },
          end: {
            line: 352,
            column: 65
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 352,
            column: 53
          },
          end: {
            line: 352,
            column: 59
          }
        }, {
          start: {
            line: 352,
            column: 62
          },
          end: {
            line: 352,
            column: 65
          }
        }],
        line: 352
      },
      "22": {
        loc: {
          start: {
            line: 364,
            column: 2
          },
          end: {
            line: 372,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 364,
            column: 2
          },
          end: {
            line: 372,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 364
      },
      "23": {
        loc: {
          start: {
            line: 375,
            column: 25
          },
          end: {
            line: 375,
            column: 71
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 375,
            column: 25
          },
          end: {
            line: 375,
            column: 43
          }
        }, {
          start: {
            line: 375,
            column: 48
          },
          end: {
            line: 375,
            column: 61
          }
        }, {
          start: {
            line: 375,
            column: 65
          },
          end: {
            line: 375,
            column: 70
          }
        }],
        line: 375
      },
      "24": {
        loc: {
          start: {
            line: 377,
            column: 2
          },
          end: {
            line: 387,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 377,
            column: 2
          },
          end: {
            line: 387,
            column: 3
          }
        }, {
          start: {
            line: 379,
            column: 9
          },
          end: {
            line: 387,
            column: 3
          }
        }],
        line: 377
      },
      "25": {
        loc: {
          start: {
            line: 377,
            column: 6
          },
          end: {
            line: 377,
            column: 28
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 377,
            column: 6
          },
          end: {
            line: 377,
            column: 19
          }
        }, {
          start: {
            line: 377,
            column: 23
          },
          end: {
            line: 377,
            column: 28
          }
        }],
        line: 377
      },
      "26": {
        loc: {
          start: {
            line: 379,
            column: 9
          },
          end: {
            line: 387,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 379,
            column: 9
          },
          end: {
            line: 387,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 379
      },
      "27": {
        loc: {
          start: {
            line: 379,
            column: 13
          },
          end: {
            line: 379,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 379,
            column: 13
          },
          end: {
            line: 379,
            column: 18
          }
        }, {
          start: {
            line: 379,
            column: 22
          },
          end: {
            line: 379,
            column: 41
          }
        }],
        line: 379
      },
      "28": {
        loc: {
          start: {
            line: 380,
            column: 4
          },
          end: {
            line: 386,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 380,
            column: 4
          },
          end: {
            line: 386,
            column: 5
          }
        }, {
          start: {
            line: 382,
            column: 11
          },
          end: {
            line: 386,
            column: 5
          }
        }],
        line: 380
      },
      "29": {
        loc: {
          start: {
            line: 382,
            column: 11
          },
          end: {
            line: 386,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 382,
            column: 11
          },
          end: {
            line: 386,
            column: 5
          }
        }, {
          start: {
            line: 384,
            column: 11
          },
          end: {
            line: 386,
            column: 5
          }
        }],
        line: 382
      },
      "30": {
        loc: {
          start: {
            line: 388,
            column: 19
          },
          end: {
            line: 388,
            column: 79
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 388,
            column: 45
          },
          end: {
            line: 388,
            column: 60
          }
        }, {
          start: {
            line: 388,
            column: 63
          },
          end: {
            line: 388,
            column: 79
          }
        }],
        line: 388
      },
      "31": {
        loc: {
          start: {
            line: 390,
            column: 2
          },
          end: {
            line: 394,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 390,
            column: 2
          },
          end: {
            line: 394,
            column: 3
          }
        }, {
          start: {
            line: 392,
            column: 9
          },
          end: {
            line: 394,
            column: 3
          }
        }],
        line: 390
      },
      "32": {
        loc: {
          start: {
            line: 390,
            column: 6
          },
          end: {
            line: 390,
            column: 37
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 390,
            column: 6
          },
          end: {
            line: 390,
            column: 23
          }
        }, {
          start: {
            line: 390,
            column: 27
          },
          end: {
            line: 390,
            column: 37
          }
        }],
        line: 390
      },
      "33": {
        loc: {
          start: {
            line: 391,
            column: 17
          },
          end: {
            line: 391,
            column: 98
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 391,
            column: 50
          },
          end: {
            line: 391,
            column: 72
          }
        }, {
          start: {
            line: 391,
            column: 75
          },
          end: {
            line: 391,
            column: 98
          }
        }],
        line: 391
      },
      "34": {
        loc: {
          start: {
            line: 392,
            column: 9
          },
          end: {
            line: 394,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 392,
            column: 9
          },
          end: {
            line: 394,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 392
      },
      "35": {
        loc: {
          start: {
            line: 397,
            column: 34
          },
          end: {
            line: 397,
            column: 89
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 397,
            column: 51
          },
          end: {
            line: 397,
            column: 57
          }
        }, {
          start: {
            line: 397,
            column: 60
          },
          end: {
            line: 397,
            column: 89
          }
        }],
        line: 397
      },
      "36": {
        loc: {
          start: {
            line: 397,
            column: 60
          },
          end: {
            line: 397,
            column: 89
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 397,
            column: 80
          },
          end: {
            line: 397,
            column: 83
          }
        }, {
          start: {
            line: 397,
            column: 86
          },
          end: {
            line: 397,
            column: 89
          }
        }],
        line: 397
      },
      "37": {
        loc: {
          start: {
            line: 399,
            column: 7
          },
          end: {
            line: 399,
            column: 72
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 399,
            column: 7
          },
          end: {
            line: 399,
            column: 17
          }
        }, {
          start: {
            line: 399,
            column: 21
          },
          end: {
            line: 399,
            column: 72
          }
        }],
        line: 399
      },
      "38": {
        loc: {
          start: {
            line: 400,
            column: 7
          },
          end: {
            line: 402,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 400,
            column: 7
          },
          end: {
            line: 400,
            column: 25
          }
        }, {
          start: {
            line: 400,
            column: 29
          },
          end: {
            line: 400,
            column: 67
          }
        }, {
          start: {
            line: 401,
            column: 8
          },
          end: {
            line: 401,
            column: 61
          }
        }],
        line: 400
      },
      "39": {
        loc: {
          start: {
            line: 413,
            column: 7
          },
          end: {
            line: 421,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 413,
            column: 7
          },
          end: {
            line: 413,
            column: 21
          }
        }, {
          start: {
            line: 413,
            column: 26
          },
          end: {
            line: 413,
            column: 44
          }
        }, {
          start: {
            line: 413,
            column: 48
          },
          end: {
            line: 413,
            column: 86
          }
        }, {
          start: {
            line: 414,
            column: 8
          },
          end: {
            line: 420,
            column: 14
          }
        }],
        line: 413
      },
      "40": {
        loc: {
          start: {
            line: 417,
            column: 21
          },
          end: {
            line: 417,
            column: 95
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 417,
            column: 85
          },
          end: {
            line: 417,
            column: 91
          }
        }, {
          start: {
            line: 417,
            column: 94
          },
          end: {
            line: 417,
            column: 95
          }
        }],
        line: 417
      },
      "41": {
        loc: {
          start: {
            line: 417,
            column: 21
          },
          end: {
            line: 417,
            column: 82
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 417,
            column: 21
          },
          end: {
            line: 417,
            column: 31
          }
        }, {
          start: {
            line: 417,
            column: 35
          },
          end: {
            line: 417,
            column: 53
          }
        }, {
          start: {
            line: 417,
            column: 57
          },
          end: {
            line: 417,
            column: 82
          }
        }],
        line: 417
      },
      "42": {
        loc: {
          start: {
            line: 422,
            column: 7
          },
          end: {
            line: 424,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 422,
            column: 7
          },
          end: {
            line: 422,
            column: 21
          }
        }, {
          start: {
            line: 423,
            column: 8
          },
          end: {
            line: 423,
            column: 89
          }
        }],
        line: 422
      },
      "43": {
        loc: {
          start: {
            line: 425,
            column: 7
          },
          end: {
            line: 443,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 425,
            column: 7
          },
          end: {
            line: 425,
            column: 21
          }
        }, {
          start: {
            line: 425,
            column: 26
          },
          end: {
            line: 425,
            column: 44
          }
        }, {
          start: {
            line: 425,
            column: 48
          },
          end: {
            line: 425,
            column: 86
          }
        }, {
          start: {
            line: 426,
            column: 8
          },
          end: {
            line: 442,
            column: 14
          }
        }],
        line: 425
      },
      "44": {
        loc: {
          start: {
            line: 445,
            column: 9
          },
          end: {
            line: 489,
            column: 9
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 446,
            column: 10
          },
          end: {
            line: 471,
            column: 12
          }
        }, {
          start: {
            line: 473,
            column: 10
          },
          end: {
            line: 488,
            column: 16
          }
        }],
        line: 445
      },
      "45": {
        loc: {
          start: {
            line: 445,
            column: 9
          },
          end: {
            line: 445,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 445,
            column: 9
          },
          end: {
            line: 445,
            column: 26
          }
        }, {
          start: {
            line: 445,
            column: 30
          },
          end: {
            line: 445,
            column: 47
          }
        }],
        line: 445
      },
      "46": {
        loc: {
          start: {
            line: 459,
            column: 35
          },
          end: {
            line: 459,
            column: 78
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 459,
            column: 35
          },
          end: {
            line: 459,
            column: 46
          }
        }, {
          start: {
            line: 459,
            column: 50
          },
          end: {
            line: 459,
            column: 78
          }
        }],
        line: 459
      },
      "47": {
        loc: {
          start: {
            line: 464,
            column: 33
          },
          end: {
            line: 464,
            column: 79
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 464,
            column: 55
          },
          end: {
            line: 464,
            column: 74
          }
        }, {
          start: {
            line: 464,
            column: 77
          },
          end: {
            line: 464,
            column: 79
          }
        }],
        line: 464
      },
      "48": {
        loc: {
          start: {
            line: 465,
            column: 27
          },
          end: {
            line: 465,
            column: 70
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 465,
            column: 43
          },
          end: {
            line: 465,
            column: 56
          }
        }, {
          start: {
            line: 465,
            column: 59
          },
          end: {
            line: 465,
            column: 70
          }
        }],
        line: 465
      },
      "49": {
        loc: {
          start: {
            line: 485,
            column: 13
          },
          end: {
            line: 487,
            column: 13
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 485,
            column: 13
          },
          end: {
            line: 485,
            column: 51
          }
        }, {
          start: {
            line: 486,
            column: 14
          },
          end: {
            line: 486,
            column: 67
          }
        }],
        line: 485
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0
    },
    b: {
      "0": [0],
      "1": [0],
      "2": [0],
      "3": [0],
      "4": [0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0, 0, 0],
      "15": [0, 0, 0, 0, 0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0],
      "37": [0, 0],
      "38": [0, 0, 0],
      "39": [0, 0, 0, 0],
      "40": [0, 0],
      "41": [0, 0, 0],
      "42": [0, 0],
      "43": [0, 0, 0, 0],
      "44": [0, 0],
      "45": [0, 0],
      "46": [0, 0],
      "47": [0, 0],
      "48": [0, 0],
      "49": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "482117482636475e89d933b83b0bb6fb3c071f42"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_173s6xv8tv = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_173s6xv8tv();
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.includes.js";
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { Box, Text } from '@opendoor/bricks-next';
import 'url-polyfill';
import 'url-search-params-polyfill';
import { NamelessAccountContext } from "../../growth/auth/NamelessAccountContext.mjs";
import { t } from "../../i18n/translationHelper.mjs";
import AccountEmailForm from "./AccountEmailForm.mjs";
import AccountFormSubHeader from "./AccountFormSubHeader.mjs";
import AccountPasswordForm from "./AccountPasswordForm.mjs";
import CheckEmailForm from "./CheckEmailForm.mjs";
import { ErrorPrompt } from "./ErrorPrompt.mjs";
import { GoogleAuth } from "./GoogleAuth.mjs";
import PasswordlessResultPage from "./PasswordlessResultPage.mjs";
import { AccountFormHeader, AccountFormWrapper, EmailDisclaimerText, FormWrapper } from "./shared.mjs";
var GOOGLE_CLIENT_ID = (cov_173s6xv8tv().s[0]++, '121750171886-1udhbfom8jjascfnsscaupb7n4p17csm.apps.googleusercontent.com');

// Simple Divider component to replace legacy Bricks Divider
cov_173s6xv8tv().s[1]++;
var Divider = function Divider() {
  cov_173s6xv8tv().f[0]++;
  cov_173s6xv8tv().s[2]++;
  return /*#__PURE__*/React.createElement(Box, {
    height: 1,
    backgroundColor: "$borderSecondary",
    width: "100%",
    my: "$4x"
  });
};
cov_173s6xv8tv().s[3]++;
var AccountForm = function AccountForm(_ref) {
  var analyticsName = _ref.analyticsName,
    _ref$phone = _ref.phone,
    phone = _ref$phone === void 0 ? (cov_173s6xv8tv().b[0][0]++, '') : _ref$phone,
    _ref$email = _ref.email,
    initialEmail = _ref$email === void 0 ? (cov_173s6xv8tv().b[1][0]++, '') : _ref$email,
    _ref$name = _ref.name,
    initialName = _ref$name === void 0 ? (cov_173s6xv8tv().b[2][0]++, '') : _ref$name,
    loginHeaderText = _ref.loginHeaderText,
    registrationHeaderText = _ref.registrationHeaderText,
    loginSubHeaderText = _ref.loginSubHeaderText,
    registrationSubHeaderText = _ref.registrationSubHeaderText,
    emailLoading = _ref.emailLoading,
    passwordLoading = _ref.passwordLoading,
    error = _ref.error,
    phoneNumberInputOptional = _ref.phoneNumberInputOptional,
    phoneNumberInputHidden = _ref.phoneNumberInputHidden,
    openForgotPasswordInNewTab = _ref.openForgotPasswordInNewTab,
    _ref$showGoogleAuth = _ref.showGoogleAuth,
    showGoogleAuth = _ref$showGoogleAuth === void 0 ? (cov_173s6xv8tv().b[3][0]++, false) : _ref$showGoogleAuth,
    overrideHasSubmittedEmailCheckForLogin = _ref.overrideHasSubmittedEmailCheckForLogin,
    emailMismatch = _ref.emailMismatch,
    customEmailValidityCheck = _ref.customEmailValidityCheck,
    customEmailValidityCheckDelay = _ref.customEmailValidityCheckDelay,
    requestResetPassword = _ref.requestResetPassword,
    _ref$hidePasswordFiel = _ref.hidePasswordField,
    hidePasswordField = _ref$hidePasswordFiel === void 0 ? (cov_173s6xv8tv().b[4][0]++, false) : _ref$hidePasswordFiel,
    onPasswordlessLoginRequest = _ref.onPasswordlessLoginRequest,
    onboardingAccountPageCTA = _ref.onboardingAccountPageCTA,
    fullNamePlaceholder = _ref.fullNamePlaceholder,
    fullNameLabel = _ref.fullNameLabel,
    disclaimerProps = _ref.disclaimerProps,
    passwordFormActionText = _ref.passwordFormActionText,
    EmailInput = _ref.EmailInput,
    NameInput = _ref.NameInput,
    PhoneInput = _ref.PhoneInput,
    PasswordInput = _ref.PasswordInput,
    onHumanStatusRequest = _ref.onHumanStatusRequest,
    onLogin = _ref.onLogin,
    onRegister = _ref.onRegister,
    postEmailCtaSection = _ref.postEmailCtaSection,
    unsetContainer = _ref.unsetContainer,
    fullNameOptional = _ref.fullNameOptional,
    fullNameHidden = _ref.fullNameHidden,
    props = _objectWithoutProperties(_ref, _excluded);
  cov_173s6xv8tv().f[1]++;
  var _ref2 = (cov_173s6xv8tv().s[4]++, useState(initialEmail)),
    _ref3 = _slicedToArray(_ref2, 2),
    email = _ref3[0],
    setEmail = _ref3[1];
  var emailInputRef = (cov_173s6xv8tv().s[5]++, useRef(null));
  var passwordInputRef = (cov_173s6xv8tv().s[6]++, useRef(null));
  cov_173s6xv8tv().s[7]++;
  useEffect(function () {
    cov_173s6xv8tv().f[2]++;
    cov_173s6xv8tv().s[8]++;
    if (emailInputRef.current) {
      cov_173s6xv8tv().b[5][0]++;
      var emailInput = (cov_173s6xv8tv().s[9]++, emailInputRef.current);
      cov_173s6xv8tv().s[10]++;
      emailInput.focus();
    } else {
      cov_173s6xv8tv().b[5][1]++;
    }
  }, []);
  var _ref4 = (cov_173s6xv8tv().s[11]++, useState(initialName)),
    _ref5 = _slicedToArray(_ref4, 2),
    name = _ref5[0],
    setName = _ref5[1];

  //Login States

  var _ref6 = (cov_173s6xv8tv().s[12]++, useState(props.isNewHuman)),
    _ref7 = _slicedToArray(_ref6, 2),
    isNewHuman = _ref7[0],
    setIsNewHuman = _ref7[1];
  var _ref8 = (cov_173s6xv8tv().s[13]++, useState(props.hasGeneratedPassword)),
    _ref9 = _slicedToArray(_ref8, 2),
    hasGeneratedPassword = _ref9[0],
    setHasGeneratedPassword = _ref9[1];
  var _ref10 = (cov_173s6xv8tv().s[14]++, useState(false)),
    _ref11 = _slicedToArray(_ref10, 2),
    googleLoginAttempt = _ref11[0],
    setGoogleLoginAttempt = _ref11[1];
  var _ref12 = (cov_173s6xv8tv().s[15]++, useState(false)),
    _ref13 = _slicedToArray(_ref12, 2),
    isRequestingPasswordlessLogin = _ref13[0],
    setIsRequestingPasswordlessLogin = _ref13[1];
  var _ref14 = (cov_173s6xv8tv().s[16]++, useState()),
    _ref15 = _slicedToArray(_ref14, 2),
    hasPasswordlessLoginRequestSucceeded = _ref15[0],
    setHasPasswordlessLogingRequestSucceeded = _ref15[1];
  var _ref16 = (cov_173s6xv8tv().s[17]++, useContext(NamelessAccountContext)),
    shouldRegisterOnEmailSubmit = _ref16.shouldRegisterOnEmailSubmit,
    emailRegistrationError = _ref16.emailRegistrationError,
    onAccountUpdate = _ref16.onAccountUpdate;
  cov_173s6xv8tv().s[18]++;
  var handleLogin = function handleLogin(password) {
    cov_173s6xv8tv().f[3]++;
    cov_173s6xv8tv().s[19]++;
    setGoogleLoginAttempt(false);
    cov_173s6xv8tv().s[20]++;
    onLogin(email, password);
  };
  cov_173s6xv8tv().s[21]++;
  var handleGoogleLogin = /*#__PURE__*/function () {
    var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(googleLoginResponse) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            cov_173s6xv8tv().f[4]++;
            cov_173s6xv8tv().s[22]++;
            setGoogleLoginAttempt(true);
            cov_173s6xv8tv().s[23]++;
            onRegister(null, null, null, null, googleLoginResponse.tokenId);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleGoogleLogin(_x) {
      return _ref17.apply(this, arguments);
    };
  }();
  cov_173s6xv8tv().s[24]++;
  var handleRegister = function handleRegister(password, name, phone) {
    cov_173s6xv8tv().f[5]++;
    cov_173s6xv8tv().s[25]++;
    setGoogleLoginAttempt(false);
    cov_173s6xv8tv().s[26]++;
    onRegister(email, name, password, phone);
  };
  var handleEmailSubmit = (cov_173s6xv8tv().s[27]++, useCallback( /*#__PURE__*/function () {
    var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(email, name) {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            cov_173s6xv8tv().f[6]++;
            cov_173s6xv8tv().s[28]++;
            if (!onHumanStatusRequest) {
              _context2.next = 9;
              break;
            }
            cov_173s6xv8tv().b[6][0]++;
            cov_173s6xv8tv().s[29]++;
            _context2.next = 7;
            return onHumanStatusRequest(email, name);
          case 7:
            _context2.next = 10;
            break;
          case 9:
            cov_173s6xv8tv().b[6][1]++;
          case 10:
            cov_173s6xv8tv().s[30]++;
            setEmail(email);
            cov_173s6xv8tv().s[31]++;
            setName(name);
          case 14:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x2, _x3) {
      return _ref18.apply(this, arguments);
    };
  }(), [onHumanStatusRequest]));
  cov_173s6xv8tv().s[32]++;
  var handleRequestPasswordlessLogin = /*#__PURE__*/function () {
    var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var _ref20, success;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            cov_173s6xv8tv().f[7]++;
            cov_173s6xv8tv().s[33]++;
            if (!onPasswordlessLoginRequest) {
              _context3.next = 17;
              break;
            }
            cov_173s6xv8tv().b[7][0]++;
            cov_173s6xv8tv().s[34]++;
            setIsRequestingPasswordlessLogin(true);
            cov_173s6xv8tv().s[35]++;
            _context3.next = 9;
            return onPasswordlessLoginRequest(email);
          case 9:
            _ref20 = _context3.sent;
            success = _ref20.success;
            cov_173s6xv8tv().s[36]++;
            setIsRequestingPasswordlessLogin(false);
            cov_173s6xv8tv().s[37]++;
            setHasPasswordlessLogingRequestSucceeded(!!success);
            _context3.next = 18;
            break;
          case 17:
            cov_173s6xv8tv().b[7][1]++;
          case 18:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function handleRequestPasswordlessLogin() {
      return _ref19.apply(this, arguments);
    };
  }();

  // Toggles to the email request view and allows user to change the email being used to log in
  cov_173s6xv8tv().s[38]++;
  var resetValidEmail = function resetValidEmail(e) {
    cov_173s6xv8tv().f[8]++;
    cov_173s6xv8tv().s[39]++;
    e === null || e === void 0 || e.preventDefault();
    cov_173s6xv8tv().s[40]++;
    setEmail('');
    cov_173s6xv8tv().s[41]++;
    setHasGeneratedPassword(false);
    cov_173s6xv8tv().s[42]++;
    setIsNewHuman(false);
  };
  cov_173s6xv8tv().s[43]++;
  var socialLoginErrorMessage = function socialLoginErrorMessage(provider, emailMismatch, email) {
    cov_173s6xv8tv().f[9]++;
    cov_173s6xv8tv().s[44]++;
    if ((cov_173s6xv8tv().b[9][0]++, emailMismatch) && (cov_173s6xv8tv().b[9][1]++, email) && (cov_173s6xv8tv().b[9][2]++, email !== '')) {
      cov_173s6xv8tv().b[8][0]++;
      cov_173s6xv8tv().s[45]++;
      return t('socialLoginEmailMismatch', {
        email: email
      });
    } else {
      cov_173s6xv8tv().b[8][1]++;
    }
    cov_173s6xv8tv().s[46]++;
    return t('socialLoginError', {
      provider: provider
    });
  };
  cov_173s6xv8tv().s[47]++;
  useEffect(function () {
    cov_173s6xv8tv().f[10]++;
    cov_173s6xv8tv().s[48]++;
    setEmail(initialEmail);
    /**
     * If an email was passed check its status so that we can know whether to show
     * the log in or sign up page
     */
    cov_173s6xv8tv().s[49]++;
    if (initialEmail) {
      cov_173s6xv8tv().b[10][0]++;
      cov_173s6xv8tv().s[50]++;
      handleEmailSubmit(initialEmail);
    } else {
      cov_173s6xv8tv().b[10][1]++;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); //Making sure to only call on onmount with the initial Email
  cov_173s6xv8tv().s[51]++;
  useEffect(function () {
    cov_173s6xv8tv().f[11]++;
    cov_173s6xv8tv().s[52]++;
    setIsNewHuman(!!props.isNewHuman);
    cov_173s6xv8tv().s[53]++;
    setHasGeneratedPassword(props.hasGeneratedPassword);
  }, [props.hasGeneratedPassword, props.isNewHuman]);
  var updatingIsNewHuman = (cov_173s6xv8tv().s[54]++, useRef(false));
  cov_173s6xv8tv().s[55]++;
  useEffect(function () {
    cov_173s6xv8tv().f[12]++;
    cov_173s6xv8tv().s[56]++;
    if (props.hasGeneratedPassword !== hasGeneratedPassword) {
      cov_173s6xv8tv().b[11][0]++;
      cov_173s6xv8tv().s[57]++;
      setHasGeneratedPassword(!!props.hasGeneratedPassword);
    } else {
      cov_173s6xv8tv().b[11][1]++;
    }
    cov_173s6xv8tv().s[58]++;
    if (props.isNewHuman !== isNewHuman) {
      cov_173s6xv8tv().b[12][0]++;
      cov_173s6xv8tv().s[59]++;
      setIsNewHuman(!!props.isNewHuman);
      cov_173s6xv8tv().s[60]++;
      updatingIsNewHuman.current = true;
    } else {
      cov_173s6xv8tv().b[12][1]++;
    }
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [initialEmail, props.hasGeneratedPassword, props.isNewHuman]);
  var hasEmailRegisterError = (cov_173s6xv8tv().s[61]++, (cov_173s6xv8tv().b[13][0]++, shouldRegisterOnEmailSubmit) && (cov_173s6xv8tv().b[13][1]++, !!emailRegistrationError));
  var hasSubmittedEmail = (cov_173s6xv8tv().s[62]++, (cov_173s6xv8tv().b[14][0]++, email) && (cov_173s6xv8tv().b[14][1]++, email.length > 0) && (cov_173s6xv8tv().b[14][2]++, !emailLoading) && (cov_173s6xv8tv().b[14][3]++, !hasEmailRegisterError));

  // This logic allows skipping the password page in cases where an onAccountUpdate method is configured
  // using the NamelessAccountContext, all password page fields are hidden, and the account is for a new
  // human. Due to the way the isNewHuman state is maintained, an additional check must be performed to
  // make sure we don't invoke the callback before the state in this component is updated after the email
  // is entered and onHumanStatusRequest is invoked to actually update the isNewHuman state via a prop.
  // Note that we are not using onRegister because onRegister requires a password, and thus we wouldn't
  // be skipping the password page.
  var skipPasswordPage = (cov_173s6xv8tv().s[63]++, (cov_173s6xv8tv().b[15][0]++, isNewHuman) && (cov_173s6xv8tv().b[15][1]++, hidePasswordField) && (cov_173s6xv8tv().b[15][2]++, fullNameHidden) && (cov_173s6xv8tv().b[15][3]++, phoneNumberInputHidden) && (cov_173s6xv8tv().b[15][4]++, shouldRegisterOnEmailSubmit) && (cov_173s6xv8tv().b[15][5]++, !!onAccountUpdate));
  cov_173s6xv8tv().s[64]++;
  useEffect(function () {
    cov_173s6xv8tv().f[13]++;
    cov_173s6xv8tv().s[65]++;
    if (updatingIsNewHuman.current) {
      cov_173s6xv8tv().b[16][0]++;
      cov_173s6xv8tv().s[66]++;
      updatingIsNewHuman.current = false;
      cov_173s6xv8tv().s[67]++;
      return;
    } else {
      cov_173s6xv8tv().b[16][1]++;
    }
    cov_173s6xv8tv().s[68]++;
    if ((cov_173s6xv8tv().b[18][0]++, hasSubmittedEmail) && (cov_173s6xv8tv().b[18][1]++, skipPasswordPage)) {
      cov_173s6xv8tv().b[17][0]++;
      cov_173s6xv8tv().s[69]++;
      onAccountUpdate(name, phone, false);
    } else {
      cov_173s6xv8tv().b[17][1]++;
    }
  }, [hasSubmittedEmail, name, onAccountUpdate, phone, skipPasswordPage]);
  cov_173s6xv8tv().s[70]++;
  if ((cov_173s6xv8tv().b[20][0]++, hasSubmittedEmail) && (cov_173s6xv8tv().b[20][1]++, hasGeneratedPassword)) {
    cov_173s6xv8tv().b[19][0]++;
    cov_173s6xv8tv().s[71]++;
    return /*#__PURE__*/React.createElement(AccountFormWrapper, {
      maxWidth: unsetContainer ? (cov_173s6xv8tv().b[21][0]++, '100%') : (cov_173s6xv8tv().b[21][1]++, 480)
    }, /*#__PURE__*/React.createElement(CheckEmailForm, {
      analyticsName: analyticsName,
      email: email,
      hasGeneratedPassword: hasGeneratedPassword,
      onResetValidEmail: resetValidEmail,
      requestResetPassword: requestResetPassword
    }));
  } else {
    cov_173s6xv8tv().b[19][1]++;
  }
  cov_173s6xv8tv().s[72]++;
  if (hasPasswordlessLoginRequestSucceeded !== undefined) {
    cov_173s6xv8tv().b[22][0]++;
    cov_173s6xv8tv().s[73]++;
    return /*#__PURE__*/React.createElement(PasswordlessResultPage, {
      hasSucceeded: hasPasswordlessLoginRequestSucceeded,
      email: email,
      analyticsName: analyticsName
    });
  } else {
    cov_173s6xv8tv().b[22][1]++;
  }

  // TODO: Clean up error handling
  var hasGoogleError = (cov_173s6xv8tv().s[74]++, (cov_173s6xv8tv().b[23][0]++, googleLoginAttempt) && ((cov_173s6xv8tv().b[23][1]++, emailMismatch) || (cov_173s6xv8tv().b[23][2]++, error)));
  var loginErrorMessage = (cov_173s6xv8tv().s[75]++, '');
  cov_173s6xv8tv().s[76]++;
  if ((cov_173s6xv8tv().b[25][0]++, emailMismatch) && (cov_173s6xv8tv().b[25][1]++, email)) {
    cov_173s6xv8tv().b[24][0]++;
    cov_173s6xv8tv().s[77]++;
    loginErrorMessage = t('emailMismatchError', {
      email: email
    });
  } else {
    cov_173s6xv8tv().b[24][1]++;
    cov_173s6xv8tv().s[78]++;
    if ((cov_173s6xv8tv().b[27][0]++, error) && (cov_173s6xv8tv().b[27][1]++, !googleLoginAttempt)) {
      cov_173s6xv8tv().b[26][0]++;
      cov_173s6xv8tv().s[79]++;
      if (error.includes('You have one more attempt before your account is locked.')) {
        cov_173s6xv8tv().b[28][0]++;
        cov_173s6xv8tv().s[80]++;
        loginErrorMessage = t('oneMoreAttemptError');
      } else {
        cov_173s6xv8tv().b[28][1]++;
        cov_173s6xv8tv().s[81]++;
        if (error.includes('Your account is locked.')) {
          cov_173s6xv8tv().b[29][0]++;
          cov_173s6xv8tv().s[82]++;
          loginErrorMessage = t('accountLockedError');
        } else {
          cov_173s6xv8tv().b[29][1]++;
          cov_173s6xv8tv().s[83]++;
          loginErrorMessage = t('invalidCredentialsError');
        }
      }
    } else {
      cov_173s6xv8tv().b[26][1]++;
    }
  }
  var headerText = (cov_173s6xv8tv().s[84]++, loginHeaderText != null ? (cov_173s6xv8tv().b[30][0]++, loginHeaderText) : (cov_173s6xv8tv().b[30][1]++, t('loginHeader')));
  cov_173s6xv8tv().s[85]++;
  if ((cov_173s6xv8tv().b[32][0]++, hasSubmittedEmail) && (cov_173s6xv8tv().b[32][1]++, isNewHuman)) {
    cov_173s6xv8tv().b[31][0]++;
    cov_173s6xv8tv().s[86]++;
    headerText = registrationHeaderText != null ? (cov_173s6xv8tv().b[33][0]++, registrationHeaderText) : (cov_173s6xv8tv().b[33][1]++, t('registrationHeader'));
  } else {
    cov_173s6xv8tv().b[31][1]++;
    cov_173s6xv8tv().s[87]++;
    if (hasSubmittedEmail) {
      cov_173s6xv8tv().b[34][0]++;
      cov_173s6xv8tv().s[88]++;
      headerText = t('welcomeBack');
    } else {
      cov_173s6xv8tv().b[34][1]++;
    }
  }
  cov_173s6xv8tv().s[89]++;
  return /*#__PURE__*/React.createElement(AccountFormWrapper, {
    maxWidth: unsetContainer ? (cov_173s6xv8tv().b[35][0]++, '100%') : (cov_173s6xv8tv().b[35][1]++, hasSubmittedEmail ? (cov_173s6xv8tv().b[36][0]++, 560) : (cov_173s6xv8tv().b[36][1]++, 480))
  }, (cov_173s6xv8tv().b[37][0]++, headerText) && (cov_173s6xv8tv().b[37][1]++, /*#__PURE__*/React.createElement(AccountFormHeader, null, headerText)), (cov_173s6xv8tv().b[38][0]++, !hasSubmittedEmail) && (cov_173s6xv8tv().b[38][1]++, (disclaimerProps === null || disclaimerProps === void 0 ? void 0 : disclaimerProps.location) !== 'bottom') && (cov_173s6xv8tv().b[38][2]++, /*#__PURE__*/React.createElement(EmailDisclaimerText, {
    analyticsName: analyticsName
  })), /*#__PURE__*/React.createElement(AccountFormSubHeader, {
    isNewHuman: isNewHuman,
    email: email,
    hasSubmittedEmail: hasSubmittedEmail,
    loginSubHeaderText: loginSubHeaderText,
    registrationSubHeaderText: registrationSubHeaderText,
    onValidEmailReset: resetValidEmail,
    hidePasswordField: hidePasswordField,
    phoneNumberInputHidden: phoneNumberInputHidden
  }), (cov_173s6xv8tv().b[39][0]++, showGoogleAuth) && ((cov_173s6xv8tv().b[39][1]++, !hasSubmittedEmail) || (cov_173s6xv8tv().b[39][2]++, overrideHasSubmittedEmailCheckForLogin)) && (cov_173s6xv8tv().b[39][3]++, /*#__PURE__*/React.createElement(Box, {
    justifyContent: "center",
    alignItems: "center",
    marginTop: (cov_173s6xv8tv().b[41][0]++, headerText) || (cov_173s6xv8tv().b[41][1]++, loginSubHeaderText) || (cov_173s6xv8tv().b[41][2]++, registrationSubHeaderText) ? (cov_173s6xv8tv().b[40][0]++, '$20x') : (cov_173s6xv8tv().b[40][1]++, 0)
  }, /*#__PURE__*/React.createElement(GoogleAuth, {
    onAuthed: handleGoogleLogin,
    clientId: GOOGLE_CLIENT_ID
  }))), (cov_173s6xv8tv().b[42][0]++, hasGoogleError) && (cov_173s6xv8tv().b[42][1]++, /*#__PURE__*/React.createElement(ErrorPrompt, {
    message: socialLoginErrorMessage('Google', emailMismatch, email)
  })), (cov_173s6xv8tv().b[43][0]++, showGoogleAuth) && ((cov_173s6xv8tv().b[43][1]++, !hasSubmittedEmail) || (cov_173s6xv8tv().b[43][2]++, overrideHasSubmittedEmailCheckForLogin)) && (cov_173s6xv8tv().b[43][3]++, /*#__PURE__*/React.createElement(Box, {
    gap: "$4x",
    marginTop: "$20x",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row"
  }, /*#__PURE__*/React.createElement(Box, {
    flex: 1
  }, /*#__PURE__*/React.createElement(Divider, null)), /*#__PURE__*/React.createElement(Text, {
    typography: "$bodyMedium",
    tag: "p",
    color: "$contentTertiary",
    paddingHorizontal: 7
  }, "or"), /*#__PURE__*/React.createElement(Box, {
    flex: 1
  }, /*#__PURE__*/React.createElement(Divider, null)))), /*#__PURE__*/React.createElement(FormWrapper, {
    marginTop: "$20x"
  }, (cov_173s6xv8tv().b[45][0]++, hasSubmittedEmail) && (cov_173s6xv8tv().b[45][1]++, !skipPasswordPage) ? (cov_173s6xv8tv().b[44][0]++, /*#__PURE__*/React.createElement(AccountPasswordForm, {
    analyticsName: analyticsName,
    email: email,
    name: name,
    phone: phone,
    loading: passwordLoading,
    isNewHuman: isNewHuman,
    loginError: loginErrorMessage,
    onLogin: handleLogin,
    onRegister: handleRegister,
    phoneNumberInputOptional: phoneNumberInputOptional,
    phoneNumberInputHidden: phoneNumberInputHidden,
    openForgotPasswordInNewTab: openForgotPasswordInNewTab,
    showPasswordlessLogin: (cov_173s6xv8tv().b[46][0]++, !isNewHuman) && (cov_173s6xv8tv().b[46][1]++, !!onPasswordlessLoginRequest),
    onRequestPasswordlessLogin: handleRequestPasswordlessLogin,
    isRequestingPasswordlessLogin: isRequestingPasswordlessLogin,
    hidePasswordField: hidePasswordField,
    onboardingAccountPageCTA: onboardingAccountPageCTA,
    fullNamePlaceholder: fullNamePlaceholder ? (cov_173s6xv8tv().b[47][0]++, fullNamePlaceholder) : (cov_173s6xv8tv().b[47][1]++, ''),
    fullNameLabel: fullNameLabel ? (cov_173s6xv8tv().b[48][0]++, fullNameLabel) : (cov_173s6xv8tv().b[48][1]++, 'Full name'),
    disclaimerProps: disclaimerProps,
    ref: passwordInputRef,
    passwordFormActionText: passwordFormActionText,
    fullNameOptional: fullNameOptional,
    fullNameHidden: fullNameHidden
  })) : (cov_173s6xv8tv().b[44][1]++, /*#__PURE__*/React.createElement(Box, {
    gap: "$12x"
  }, /*#__PURE__*/React.createElement(AccountEmailForm, {
    analyticsName: analyticsName,
    email: email,
    ref: emailInputRef,
    loading: emailLoading,
    onSubmit: handleEmailSubmit,
    openForgotPasswordInNewTab: openForgotPasswordInNewTab,
    customEmailValidityCheck: customEmailValidityCheck,
    customEmailValidityCheckDelay: customEmailValidityCheckDelay,
    showForgotPassword: !hidePasswordField
  }), (cov_173s6xv8tv().b[49][0]++, (disclaimerProps === null || disclaimerProps === void 0 ? void 0 : disclaimerProps.location) === 'bottom') && (cov_173s6xv8tv().b[49][1]++, /*#__PURE__*/React.createElement(EmailDisclaimerText, {
    analyticsName: analyticsName
  }))))));
};
export default AccountForm;
//# sourceMappingURL=AccountForm.mjs.map